import { mapGetters } from "vuex";
import WithRender from "../../templates/ui/table.html";

export default WithRender({
  computed: {
     ...mapGetters(["getIsStoreCodeStiegl"])},
  props: ["tableName", "tableClass", "isQuantityTable"]
});
